<template>
    <article id="product-page" class="products-page clp page">         
        <ProductsCategoryMenu />
        <div  v-if="getDataSuccess">
            <div class="products-page__blocks-wrap" v-if="productsInCategory.length > 0">
                <section v-for="categoryBlock in productsInCategory" :key="categoryBlock.categoryId + '_section' + currentLangName()" class="clp__section">
                    <div class="container" v-if="categoryBlock.products">
                        <h3>{{ categoryBlock.categoryName }}</h3>
                        <div class="carousel-outer-wrap">
                            <div class="carousel-wrap">
                                <carousel v-if="categoryBlock.products" :items="4" :margin="30" :autoWidth="true" :dots="false"  :loop="false" :responsive="{ 
                                    0:{
                                        items:1,
                                        autoWidth: true,
                                        margin: 20,
                                        mouseDrag: true,                                 
                                        nav: false},      
                                    576:{items:3, mouseDrag:true, nav:false, margin: 20},
                                    768:{items:3, mouseDrag:true, margin: 20},                            
                                    992:{items:3, mouseDrag:false},
                                    1200:{items:4, mouseDrag:false}                            
                        }">                                     
                                        <ProductItem v-for="product in categoryBlock.products" 
                                            :key="product.id" 
                                            :name="product.name" 
                                            :categoryId="product.category_id" 
                                            :product_slug="product.slug" 
                                            :srcset="itemSrcset(product)" 
                                            :src="itemSrc(product, 'w286h440')"
                                            :id="product.id"                                             
                                        />
                                </carousel>            
                            </div>   
                        </div>                                                            
                        <div class="carousel-block-btn-wrap">
                            <div class="btn-primary-wrap" @click="GTMProdCatClick(categoryBlock.categorySlug)">
                                <router-link  :to="{name: 'ProductsCategoryList_'+ currentLangName(), params:{ product_category_slug: categoryBlock.categorySlug} }" class="btn btn--primary"><span >{{ lang("osszes_termek_megtekintese_btn_text")}}</span></router-link>
                            </div>
                        </div>
                    </div>
                </section>  
            </div>   
            <div v-else class="no-result">{{lang('nincs_talalat')}}</div>       
        </div>
        <div v-else>
            <Loading />          
        </div>
    </article>
</template>

<script>
import axios from 'axios'
import carousel from 'vue-owl-carousel'
import ProductItem from '@/components/pagesComponents/products/ProductItem.vue'
import ProductsCategoryMenu from '@/components/pagesComponents/products/ProductsCategoryMenu.vue'
import Loading from '@/components/layoutComponents/Loading.vue'

export default {
    data(){
        return {                        
            productsInCategory: [],
            allProducts: [],
            getDataSuccess: false 
        }
    },
    components:{
        carousel,
        ProductItem,
        ProductsCategoryMenu,
        Loading
    },
    computed:{       
        productsCategory(){
            //all category in products category --> where parent category id = 1
            return this.$store.getters.getProducstCategory; 
        }              
    },
    methods:{
        selectedCategory(products, actCategory){                    
            return products.filter(function(product) {                                
                return product.category_id == actCategory.category_id
            })
        },
        selectionProducts(){
            var _this = this;
            var selectedProds = []

            //select the result by category_id
            _this.allProducts.forEach( element => {                                
                 
                let currentElementCategories = this.getCategoryData(element.id, this.$store.getters.getProducstCategory)

                currentElementCategories.forEach( category => {
                    var itemIndex = selectedProds.findIndex(x => x.categoryId == category.id);

                    if (itemIndex > -1){
                        selectedProds[itemIndex].products.push(element)
                    } else {
                        selectedProds.push( {
                            categoryId: category.id,
                            products: [element],
                            categoryName: category.name,
                            categorySlug: category.slug,
                            categorySortOrder: category.sort_order
                        })
                    }  
                })
            
            })

            //sort the array by sort_order
            selectedProds = selectedProds.sort(this.sortSelectedProducts);
            
            _this.productsInCategory = selectedProds; 
            this.getDataSuccess = true           
        },
        sortSelectedProducts(a,b){
            var sortOrderA = parseInt(a.categorySortOrder);
            var sortOrderB = parseInt(b.categorySortOrder);            

            let comparison = 0;
            if (sortOrderA > sortOrderB) {
                comparison = 1;
            } else if (sortOrderA < sortOrderB) {
                comparison = -1;
            }            
            return comparison;
        },
        getProducts(){
            //items
            let _this = this;
             
            // 2 id filter -- product category list page - featured products
            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/filter/2?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=sort_order&relations_params[information][order_by][0][1]=asc&relations_params[information][order_by][1][0]=name&relations_params[information][order_by][1][1]=asc',{        
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id,            
                }
            }).then(response => {                
                if (response.data.status == true) {
                    _this.allProducts = [];
                    if (_this.$store.state.needPD){
                        for (var i=0; i < response.data.filter[0].information.length ;i++)
                        {
                            if (response.data.filter[0].information[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                                 _this.allProducts.push(response.data.filter[0].information[i]);
                        }
                        
                    }
                    else
                        _this.allProducts = response.data.filter[0].information;
                    _this.selectionProducts();
                } else {
                    _this.getDataSuccess = true
                    _this.allProducts = []
                }
                                          
            })
            .catch((err) => {
                console.log(err)
            });
        },
        GTMProdCatClick(category){          
            this.setDataLayer('product', category, '')                  
        }         
    },
    created(){           
        this.getProducts();         
    },
    mounted(){
        this.setMetaTags({
            title: this.lang('title_termekek'), 
            desc: this.lang('meta_desciption_termekek'), 
            keywords:this.lang('meta_keywords_termekek'), 
            ogType: 'products', 
            ogTitle: this.lang('title_termekek'),                         
            ogImage: null, 
            ogImageWidth: null, 
            ogImageHeight: null, 
            ogDesc:this.lang('meta_desciption_termekek')
        })
    }
}
</script>